<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-end mb-2 flex-shrink-0">
			<v-select
				v-model="options.type"
				:items="optionsType"
				:menu-props="{ top: true, offsetY: true }"
				label="Tipo"
				class="custom-height-search custom-height-calendar mb-0 mr-1 w-100"
				outlined
				dense
				required
				style="max-width: 120px;"
			></v-select>
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="$store.state.users.loadingUserList"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.users.usersListCount"
				:loading-info="$store.state.users.loadingUserList"
			/>
		</div>
		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				:headers="headers"
				:items="$store.state.users.usersList"
				:search="search"
				item-key="id"
				:loading="$store.state.users.loadingUserList"
				:server-items-length="$store.state.users.usersListCount"
				:options.sync="options"
				loading-text="Cargando datos..."
				class="crm-table"
				disable-sort
				hide-default-header
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:item.name="{ item }">
					<div class="d-flex align-center" :style="item.company[0]?.deleted_at ? 'opacity: 0.5;' : ''">
						<img :src="item.profile.avatar" class="user-avatar mr-2" v-if="item?.profile?.avatar"/>
						<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
						<div>
							<p class="mb-0">{{ item.profile?.name }} {{ item.profile?.lastname }} {{ item.profile?.second_lastname }}</p>
							<p class="mb-0 caption">{{ item.email }}</p>
						</div>
					</div>
				</template>
				<template v-slot:item.role="{ item }">
					<div class="d-flex align-center">
						<p class="mb-0">{{ item.company_rol?.role?.name }}</p>
					</div>
				</template>
				<template v-slot:item.actions="{ item }">
					<v-tooltip bottom v-if="$checkPermissions(['edit_user_permissions'])">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								x-small
								color="#959595"
								class="mx-1"
								:dark="canEditPermissions(item)"
								:disabled="!canEditPermissions(item)"
								@click.stop="() => { selectRow(item); editUserPermission(item); }"

								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-shield-edit-outline</v-icon>
							</v-btn>
						</template>
						<span>Editar Permisos</span>
					</v-tooltip>
					<!-- <v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								dark
								x-small
								color="#31D56A"
								class="mx-1"
								@click.stop="() => { selectRow(item); $router.push({ name: 'Chat', query: { user_id: item.id } }); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-chat-outline</v-icon>
							</v-btn>
						</template>
						<span>Chatear</span>
					</v-tooltip> -->
					<v-tooltip bottom v-if="$checkPermissions(['edit_users'])">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								dark
								x-small
								color="warning"
								class="mx-1"
								@click.stop="() => { selectRow(item); editUser(item); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-pencil-outline</v-icon>
							</v-btn>
						</template>
						<span>Editar</span>
					</v-tooltip>
					<v-tooltip bottom v-if="$checkPermissions(['delete_users']) && !item.company[0]?.deleted_at">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								x-small
								color="error"
								outlined
								class="mx-1"
								@click.stop="() => { selectRow(item); deleteUser(item.id); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-cancel</v-icon>
							</v-btn>
						</template>
						<span>Bloquea el acceso a la empresa para este usuario</span>
					</v-tooltip>
					<v-tooltip bottom v-else-if="$checkPermissions(['delete_users'])">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								x-small
								color="green"
								outlined
								class="mx-1"
								@click.stop="() => { selectRow(item); activateUserCompany(item.id); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-check-circle-outline</v-icon>
							</v-btn>
						</template>
						<span>Activa el acceso a la empresa para este usuario</span>
					</v-tooltip>
					<v-tooltip bottom v-if="$checkPermissions(['delete_users'])">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								dark
								x-small
								color="error"
								class="mx-1"
								@click.stop="() => { selectRow(item); deleteUser(item.id, true); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-delete-outline</v-icon>
							</v-btn>
						</template>
						<span>Eliminar</span>
					</v-tooltip>
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.users.usersListCount"
				:loading-info="$store.state.users.loadingUserList"
			/>
		</div> -->
  </v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import {removeUserFromCompany, activateUserFromCompany} from '@/helpers/api/company'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'UsersIndex',
	components: {
		DataTablePagination,
	},
  data() {
    return {
			selectedRowItem: null,
      search: '',
			searchInput: null,
			itemsPerPageOptions: [10, 25, 50, 100, 200],
			optionsType: [
				{ text: 'Activos', value: 1 },
				{ text: 'Todos', value: 2 },
				{ text: 'Bloqueados', value: 3 },
			],
      options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: [],
				type: 1
      },
      headers: [
        { text: 'Usuario', value: 'name' },
        { text: 'Rol', value: 'role' },
        // { text: 'Email', value: 'email' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
    filteredUsers() {
      return this.$store.state.users.usersList.filter(user => {
        return (
          user.name.toLowerCase().includes(this.search.toLowerCase()) ||
          user.email.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
	watch: {
    options: {
      handler() {
				this.debounceReloadInfo()
      },
      deep: true,
    },
		selectedCompany(newValue){
			if(newValue){
				this.debounceReloadInfo()
				this.$store.dispatch('companies/getRoles', {start: 0, limit: 30})
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.debounceReloadInfo()
			this.$store.dispatch('companies/getRoles', {start: 0, limit: 30})
		}
		const selectedRow = JSON.parse(localStorage.getItem('selected_userslist_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
	},
  methods: {
		canEditPermissions(item){
			return item?.company_rol?.role_id != 41
		},
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_userslist_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.reloadInfo()
		},
		debounceReloadInfo: _debounce(function() { this.reloadInfo() }, 300),
		reloadInfo(){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('users/getUserFromCompany', data)
		},
		editUserPermission(user){
			this.$store.commit('users/setEditPermissionsUser', user)
			this.$store.commit('users/setEditPermisosUserModal', true)
		},
    addUser() {
			this.$store.commit('users/setNewUserModalEditing', null)
			this.$store.commit('users/setNewUserModal', true)
    },
    editUser(user) {
			const data = {...user, ...{user_id: user.id}}
			this.$store.commit('users/setNewUserModalEditing', data)
			this.$store.commit('users/setNewUserModal', true)
    },
    async deleteUser(user_id, force_deletion = false) {
			await removeUserFromCompany({
				company_id: this.$store.state.companies.selectedCompany.company_id,
				user_id,
				force_deletion
			})
			this.debounceReloadInfo()
    },
		async activateUserCompany(user_id) {
			await activateUserFromCompany({
				company_id: this.$store.state.companies.selectedCompany.company_id,
				user_id
			})
			this.debounceReloadInfo()
    },
  },
};
</script>

<style scoped>
	/deep/ .removed-user{
		opacity: 0.5;
	}
</style>